import { observer } from 'mobx-react-lite'
import { useMemo, type FC } from 'react'
import { Avatar, type IAvatarInfo, type IAvatarProps, Tooltip } from 'shared/ui'
import { getLabelAsNumberInternationalFormat } from 'shared/lib'

type IAvatarContentProps = {
  avatarProps?: Omit<IAvatarProps, 'info'>
  avatarInfo?: IAvatarInfo | null
}

export const AvatarContent: FC<IAvatarContentProps> = observer(({ avatarInfo, avatarProps }) => {
  const tooltipLabel = useMemo(() => {
    const firstName = avatarInfo?.firstName?.trim()
    const lastName = avatarInfo?.lastName?.trim()
    const number = avatarInfo?.number?.trim()

    const words = []

    if (avatarInfo?.isPhoneAbbr) {
      if (number) words.push(getLabelAsNumberInternationalFormat(number))
    } else {
      if (firstName) words.push(firstName)
      if (lastName) words.push(lastName)
    }

    return !!words.length ? words.join(' ') : null
  }, [avatarInfo])

  return (
    <Tooltip placement='top' label={tooltipLabel}>
      <Avatar {...avatarProps} info={avatarInfo || {}} />
    </Tooltip>
  )
})
